import SimpleTrack from '@common/types/release/simple-track';
import { ReleaseType } from '@common/types/release/release-type';
import { normalizeTitle } from '@webapp/utils/normalizers';

const getSongTitleFromFilename = (filename: string, releaseType: ReleaseType, releaseTitle?: string): string => {
  if (releaseType === 'single' && releaseTitle) {
    return releaseTitle;
  }

  const name = filename.split('.').slice(0, -1).join('.');

  return normalizeTitle(name);
}

export const createNewTrack = (
  id: string,
  releaseId: string,
  releaseType: ReleaseType,
  releaseTitle: string | undefined,
  author: string,
  fileName: string,
  url: string,
  extra?: Partial<SimpleTrack>
): SimpleTrack => {
  return {
    id,
    releaseId,
    author,
    title: getSongTitleFromFilename(fileName, releaseType, releaseTitle),
    isInstantGratification: false,
    url,
    priceType: 'album-only',
    created_at: new Date(),
    updated_at: new Date(),
    ...extra
  };
}